module.exports = __webpack_public_path__ + "img/imagem-aerea-rio-de-janeiro.6ede4c88.jpg";